import React, { useEffect, useMemo, useState } from 'react'
import { Card, CardBody, CardHeader, Col, Container, Row, Spinner, Button, Input, Label } from 'reactstrap'
import TableContainer from '../../Components/Common/TableContainerReactTable';
import NotificacionesCobranzaHooks from '../../Components/Hooks/NotificacionesCobranzaHooks';
import ModalLeerNotificacion from '../../Components/modals/ModalLeerNotificacion';

const NotificacionesCobranza = () => {
    const formatDate = (date) => {
        if (!date) return '';
        const _date = new Date(date)
        const year = _date.getFullYear();
        const month = String(_date.getMonth() + 1).padStart(2, '0');
        const day = String(_date.getDate()).padStart(2, '0');
        return `${day}-${month}-${year}`;
    };

    const { notificaciones, loading, error } = NotificacionesCobranzaHooks();
    const [selectedNotificacion, setSelectedNotificacion] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedNotificacionId, setSelectedNotificacionId] = useState(null);
    const [selectedClipro, setSelectedClipro] = useState('');

    const filteredNotificaciones = useMemo(() => {
        if (!selectedClipro) return notificaciones;
        return notificaciones.filter(n => n.clipro && n.clipro.includes(selectedClipro));
    }, [notificaciones, selectedClipro]);

    useEffect(() => {
        document.title = "Notificaciones Cobranza | Siga ERP";
    }, []);

    const columns = useMemo(
        () => [
            {
                header: "ID",
                accessorKey: "id",
                enableColumnFilter: false,
            },
            {
                header: "Cliente",
                accessorKey: "clipro",
                enableColumnFilter: false
            },
            {
                header: "Estado",
                accessorKey: "status",
                enableColumnFilter: false,
            },
            {
                header: "Fecha Creación",
                accessorKey: "created_at",
                enableColumnFilter: false,
                cell: ({ getValue }) => formatDate(getValue()),
            },
            {
                header: "Destinatarios",
                accessorKey: "recipients",
                enableColumnFilter: false,
                cell: ({ getValue }) => getValue() ? getValue().map(r => r.recipient).join(', ') : '',
            },
        ],
        []
    );

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardHeader className="d-flex justify-content-between align-items-center">
                                    <h5 className="card-title mb-0">Notificaciones Cobranza</h5>
                                    <div className="d-flex align-items-center">
                                        <Button color="info" className="me-2" onClick={() => { if (selectedNotificacion) { setSelectedNotificacionId(selectedNotificacion); setIsModalOpen(true); } }} disabled={!selectedNotificacion}>
                                            <i className="ri-eye-line me-1"></i>Leer
                                        </Button>
                                        <Button color="warning" className="me-2" onClick={() => { if (selectedNotificacion) console.log('Aprobar', selectedNotificacion) }} disabled={!selectedNotificacion}>
                                            <i className="ri-check-line me-1"></i>Aprobar
                                        </Button>
                                        <Button color="primary" className="me-2" onClick={() => { if (selectedNotificacion) console.log('Enviar', selectedNotificacion) }} disabled={!selectedNotificacion}>
                                            <i className="ri-send-plane-line me-1"></i>Enviar
                                        </Button>
                                    </div>
                                </CardHeader>
                                <CardBody>
                                    <Row className="mb-3">
                                        <Col md={3}>
                                            <Label for="id">ID</Label>
                                            <Input
                                                type="text"
                                                id="id"
                                                value={selectedNotificacion}
                                                onChange={(e) => setSelectedNotificacion(e.target.value)} />
                                        </Col>
                                        <Col md={3}>
                                            <Label for="selectedClipro">RUT Cliente</Label>
                                            <Input
                                                type="text"
                                                id="selectedClipro"
                                                value={selectedClipro}
                                                onChange={(e) => setSelectedClipro(e.target.value)}
                                            />
                                        </Col>
                                    </Row>
                                    {loading ? <div className="text-center"><Spinner animation="border" variant="primary" /></div> : <TableContainer
                                        columns={(columns || [])}
                                        data={filteredNotificaciones}
                                        customPageSize={15}
                                        isGlobalFilter={true}
                                        SearchPlaceholder='Buscar...'
                                        onCellClick={(cellInfo) => {
                                            switch (cellInfo.columnId) {
                                                case 'id':
                                                    setSelectedNotificacion(cellInfo.value);
                                                    break
                                                case 'clipro':
                                                    setSelectedClipro(cellInfo.value)
                                                    break
                                                default:
                                                    break
                                            }
                                        }}
                                    />}
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
            <ModalLeerNotificacion
                isOpen={isModalOpen}
                toggle={() => setIsModalOpen(false)}
                selectedNotificacionId={selectedNotificacionId}
            />
        </React.Fragment>
    )
}

export default NotificacionesCobranza;